var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-1209 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    transform: "translate(1209 9)",
    fill: "#fff",
    stroke: "#e9e9e9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(1217.5 17.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M9.161,0A2.757,2.757,0,0,1,11.2,4.694Q9.395,6.509,7.581,8.317A5.667,5.667,0,0,1,4.47,9.9c-.607.108-1.21.237-1.815.356a.753.753,0,0,1-.915-.925c.164-.814.312-1.631.5-2.439a4.928,4.928,0,0,1,1.31-2.346Q5.443,2.627,7.359.735A2.6,2.6,0,0,1,9.161,0M3.452,8.554c.243-.047.458-.094.675-.129a4.207,4.207,0,0,0,2.366-1.16q1.8-1.807,3.607-3.609A1.246,1.246,0,1,0,8.341,1.891C7.135,3.09,5.941,4.3,4.73,5.5A4.968,4.968,0,0,0,3.452,8.554",
    transform: "translate(-0.47 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M6.5,17.744q-2.834,0-5.667,0a.745.745,0,0,1-.8-.552.744.744,0,0,1,.67-.956c.05,0,.1,0,.151,0H12.166a.761.761,0,0,1,.763.448.748.748,0,0,1-.691,1.063c-.881.007-1.763,0-2.645,0H6.5",
    transform: "translate(0.001 -4.441)",
    fill: "#0a64f9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fa2ee3e881ffd0dc4c14064717570547.svg";
export { ForwardRef as ReactComponent };